import 'reflect-metadata';
import { Expose, Transform } from 'class-transformer';
import { InvoicePositionModel } from '../finance/financial-record.model';
import { BaseInvoiceThemeModel } from './base-invoice-theme.model';
import { SectionId, SectionType, ThemeTypes } from '../../../features/invoice-theme/theme.types';
import {
  convertToContentAreaMap,
  convertToThemeObject,
  mapToContentAreasArray,
  themeToKvArray,
} from '../../../pages/finances/invoices/invoice.functions';
import { KeyValueRecord } from '../../../shared/functions/record-functions';

export class ContentArea {
  id?: number;
  type: SectionType = SectionType.Undefined;
  content?: string = '';
  meta?: Record<string, unknown> = {};
}

export class InvoiceDocumentDetailModel {
  public id?: number = null;
  public theme: ThemeTypes = 0;

  @Expose({ name: 'content_areas' })
  @Transform(({ value }) => mapToContentAreasArray(value), { toPlainOnly: true })
  @Transform(({ value }) => convertToContentAreaMap(value), { toClassOnly: true })
  public contentAreas: Map<SectionId, ContentArea> = new Map();

  public positions: InvoicePositionModel[] = [];

  /** Server: "theme-props": [{ key, value }] */
  @Expose({ name: 'theme_props' })
  @Transform(({ value }) => themeToKvArray(value), { toPlainOnly: true })
  @Transform(({ value }) => convertToThemeObject(value), { toClassOnly: true })
  public themeProps: BaseInvoiceThemeModel = null;

  /** Server: "meta": [{ key, value }] e.g. project id, brutto, vat, netto, etc. */
  public meta?: KeyValueRecord[] = [];

  @Expose({ name: 'is_template' })
  public isTemplate = false;
}
